export default __webpack_public_path__ + "static/media/dazzling_dunes.248b26b0.svg";